import { styled } from '@mui/material';

export const InfoSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  paddingTop: '1.25rem',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    gap: '3rem',
  },
}));

export const PaymentInfoItem = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'left',
  gap: '0.5rem',
  wordBreak: 'break-word',
}));

export const CpfItem = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '0.5rem',
  flexWrap: 'wrap',
  textAlign: 'start',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const CpfSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'left',
  gap: '1rem',
  paddingBottom: '1.5rem',
  flexWrap: 'wrap',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: '0.75rem',
  },
}));
